import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/remote-config';

const jsonKeys = [
  'force_update_info_android',
  'recommended_update_info_ios',
  'force_update_info_ios',
];

const numberKeys = [
  'privacy_policy_version',
  'terms_of_service_version',
  'oute_search_distance',
  'checkable_distance',
];

const stringKeys = [
  'qanda_url',
  'use_url',
  'inquiry_url',
  'site_url',
  'term_url',
  'privacy_url',
  'questionnaire_url',
  'maintenance_message',
];

const booleanKeys = ['is_user_registration_enabled', 'under_maintenance'];

@Injectable({ providedIn: 'root' })
export class RemoteConfigService {
  private readonly remoteConfig: firebase.remoteConfig.RemoteConfig;
  constructor() {
    this.remoteConfig = firebase.remoteConfig();
  }
  async fetchAndActivate() {
    try {
      await this.remoteConfig.fetchAndActivate();
    } catch (e) {
      throw new Error(e);
    }
  }

  getNumber(key: string) {
    if (numberKeys.some(k => k === key)) {
      return this.remoteConfig.getNumber(key);
    }
    throw new Error(`Invalid number key by ${key}`);
  }

  getString(key: string) {
    if (stringKeys.some(k => k === key)) {
      return this.remoteConfig.getString(key);
    }
    throw new Error(`Invalid string key by ${key}`);
  }

  getBoolean(key: string) {
    if (booleanKeys.some(k => k === key)) {
      return this.remoteConfig.getBoolean(key);
    }
    throw new Error(`Invalid boolean key by ${key}`);
  }

  getJson(key: string) {
    if (jsonKeys.some(k => k === key)) {
      const value = this.remoteConfig.getString(key);
      return JSON.parse(value);
    }
    throw new Error(`Invalid json key by ${key}`);
  }

  getValue(key: string) {
    return this.remoteConfig.getValue(key);
  }
}
